import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    border: '1px solid #EAEAEA',
    borderRadius: '4px',
    boxSizing: 'border-box',
    boxShadow: '0px 16px 24px 2px rgba(0, 0, 0, 0.08)',
    width: '100%',
    maxWidth: 'calc(100vw - 32px)',
    padding: '24px',
    backgroundColor: 'white',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    [theme.breakpoints.up('md')]: {
      maxWidth: '40vw'
    }
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px'
  },

  title: {
    fontSize: theme.size.lg,
    color: '#1F1F1F'
  },

  close: {
    cursor: 'pointer'
  },

  children: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '100%',
    height: '100%'
  }
}))

export default useStyles
